var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3494 5H5.03625C4.20561 5 3.73707 5.95405 4.24491 6.61137L7.26424 10.5195C7.65387 11.0238 8.40952 11.0399 8.82023 10.5526L12.114 6.64445C12.6621 5.99416 12.1998 5 11.3494 5Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownblock);
export default __webpack_public_path__ + "static/media/downblock.640b7e5762b497d732a0f9404aed3916.svg";
export { ForwardRef as ReactComponent };